<template>
  <div class="bg">
    <div class="part2">
      <div class="left">
        <AboutMatch />
      </div>
      <div class="right">
        <notice-item />
      </div>
    </div>
  </div>
</template>

<script>
import NoticeItem from './NoticeItem.vue'
import AboutMatch from './AboutMatch.vue'

export default {
  components: {
    NoticeItem,
    AboutMatch
  },
  props: {},
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.bg {
  /* background: url(~@/assets/images/homebg2.png); */
  background-position: center;
  background-size: 100% 100%;
}

.part2 {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  width: 1140px;
  margin: auto;

  .left {
    width: 34%;
  }

  .right {
    width: 66%;
  }
}

@media screen and (max-width: 767px) {
  .bg {
    background: url('');
    background-position: center;
    background-size: 100% 100%;
  }

  .part2 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-between;
    padding: 0;
    width: 100%;

    .left {
      width: 100%;
    }

    .right {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part2/Part2.vue